import _extends from "@babel/runtime/helpers/esm/extends";
import { ProDescriptions } from '@ant-design/pro-components';
import React, { useEffect } from 'react';
export var SuperProDescriptions = function SuperProDescriptions(properties) {
  useEffect(function () {
    var container = document.querySelector('main');
    var fixer = document.createElement('style');
    //
    fixer.innerHTML = "\n      .ant-descriptions .ant-descriptions-item-container {\n        justify-content: space-between;\n      }\n      \n      .ant-descriptions .ant-descriptions-item-content {\n        flex: unset;\n      }\n    ";

    // 插入样式
    container === null || container === void 0 || container.appendChild(fixer);
    return function () {
      container === null || container === void 0 || container.removeChild(fixer);
    };
  }, []);
  return /*#__PURE__*/React.createElement(ProDescriptions, _extends({
    column: 1
  }, properties));
};